import { isSemanticModelRelationPrimitive } from "../../concepts/index.js";
/**
 * @deprecated
 */
export const SEMANTIC_MODEL_RELATIONSHIP_USAGE = "relationship-usage";
/**
 * @deprecated
 */
export const SEMANTIC_MODEL_CLASS_USAGE = "class-usage";
/**
 * @deprecated
 */
export function isSemanticModelRelationshipUsage(resource) {
    return resource?.type?.includes(SEMANTIC_MODEL_RELATIONSHIP_USAGE) ?? false;
}
/**
 * @deprecated
 */
export function isSemanticModelClassUsage(resource) {
    return resource?.type?.includes(SEMANTIC_MODEL_CLASS_USAGE) ?? false;
}
/**
 * @deprecated
 */
export function isSemanticModelAttributeUsage(resource) {
    if (!isSemanticModelRelationshipUsage(resource)) {
        return false;
    }
    return isSemanticModelRelationPrimitive(resource);
}
//# sourceMappingURL=concepts-utils.js.map